import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import './PromotionBlock.css';

export interface IPromotionBlockProps {
    image_path: string;
    primary_color?: string;
    secondary_color?: string;
    remark_color?: string;
    promotion?: any;
    colors?: any;
}

export const PromotionBlock = (props: IPromotionBlockProps) => (
    <div style={{ margin: 20 }}>
        <Container
            style={{
                background: 'rgba(255, 255, 255, 0.65)',
                borderRadius: 20,
                margin: '16px auto',
                maxWidth: 970,
                padding: 16,
            }}
            className='PromotionBlock'
        >
            <Row>
                <Col xs={12}>
                    <p style={{ color: props.colors.primary, fontWeight: 500, fontSize: 16 }} className='MediumText'>
                        {props.promotion.header}：
                    </p>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={5}>
                    <Row>
                        <Col xs={5} style={{ paddingRight: 0 }}>
                            <img src={props.image_path + props.promotion.left.image} style={{ maxWidth: '100%' }} />
                        </Col>
                        <Col xs={7} style={{ paddingRight: 0 }}>
                            <div>
                                <div style={{ color: props.colors.secondary, fontSize: 24, fontWeight: 500 }} className='MediumText'>
                                    {props.promotion.left.prefix}<span style={{ fontSize: 36 }} className='LargeText'>{props.promotion.left.amount}</span>
                                </div>
                                <div style={{ color: props.colors.dark, fontSize: 14, lineHeight: 1 }} className='RemarkText'>
                                    {props.promotion.left.remark}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} sm={2} className='d-flex justify-content-center'>
                    <div style={{
                        background: '#4AC0B6',
                        borderRadius: '100%',
                        color: props.colors.light,
                        display: 'inline-block',
                        fontSize: 22,
                        fontWeight: 'bold',
                        height: 36,
                        margin: '8px ',
                        padding: '2px 6px',
                        width: 36,
                    }} className='align-self-center OrText'>
                        {props.promotion.or}
                    </div>
                </Col>
                <Col xs={12} sm={5}>
                    <Row>
                        <Col xs={5} style={{ paddingRight: 0 }}>
                            <img src={props.image_path + props.promotion.right.image} style={{ maxWidth: '100%' }} />
                        </Col>
                        <Col xs={7} style={{ paddingRight: 0 }}>
                            <div>
                                <div style={{ color: props.colors.secondary, fontSize: 24, fontWeight: 500 }} className='MediumText'>
                                    {props.promotion.right.prefix}<br /><span style={{ fontSize: 36, lineHeight: 1 }} className='LargeText'>{props.promotion.right.amount}</span>{props.promotion.right.suffix}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <p style={{ color: props.colors.primary, fontWeight: 500, margin: '16px 0', fontSize: 16 }} className='MediumText'>
                        {props.promotion.footer.member_purchase}<span style={{ color: props.colors.secondary, fontWeight: 700 }}>{props.promotion.footer.product}</span>*{props.promotion.footer.required_amount}<span style={{ fontSize: 14 }} className='RemarkText'>({props.promotion.footer.shipping_remark}<sup>#</sup>)</span>
                        ，{props.promotion.footer.get_gift}<span style={{ color: props.colors.highlight, fontWeight: 700 }}>{props.promotion.footer.gift}</span><span style={{ fontSize: 14 }} className='RemarkText'>({props.promotion.footer.gift_price_prefix}{props.promotion.footer.gift_price})</span>！
                    </p>
                    <ol style={{ listStyleType: 'none', paddingLeft: 0 }} className='PromotionRemarks'>
                        {props.promotion.footer.remarks.map((x: string, i: number) => (
                            <li dangerouslySetInnerHTML={{ __html: x }} key={i} />
                        ))}
                    </ol>
                </Col>
            </Row>
        </Container>
    </div >
);


// WEBPACK FOOTER //
// ./src/pages/Home/PromotionBlock/index.tsx